import { Injectable } from '@angular/core';
import { Map } from 'immutable';
import { BehaviorSubject } from 'rxjs';

import {
	ExpositionDiagnosticError,
	ExpositionErrorKey,
} from '../domain/exposition-diagnostic-errors.entity';

@Injectable()
export class ExpositionProvider {
	private readonly errorsSubject = new BehaviorSubject<
		Map<ExpositionErrorKey, ExpositionDiagnosticError>
	>(Map());
	public readonly errors$ = this.errorsSubject.asObservable();

	public getErrors(): Map<ExpositionErrorKey, ExpositionDiagnosticError> {
		return this.errorsSubject.value;
	}

	public addError(error: ExpositionDiagnosticError): void {
		const currentErrors = this.getErrors();
		const errorKey = error.key as ExpositionErrorKey;

		if (currentErrors.has(errorKey)) {
			return;
		}

		const updatedErrors = currentErrors.set(errorKey, error);
		this.errorsSubject.next(updatedErrors);
	}

	public removeError(key: ExpositionErrorKey): void {
		const currentErrors = this.getErrors();

		if (!currentErrors.has(key)) {
			return;
		}

		const updatedErrors = currentErrors.delete(key);
		this.errorsSubject.next(updatedErrors);
	}

	public getFirstError(
		keys: Array<ExpositionErrorKey>
	): ExpositionDiagnosticError | undefined {
		const errors = this.getErrors();
		for (const key of keys) {
			const error = errors.get(key);
			if (error) {
				return error;
			}
		}
		return undefined;
	}
}
